export default "__VITE_ASSET__92ab77f7__$_?nuxt_component=async__"